// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UvCAk","right":"Footer_right__XgbIy","buttons":"Footer_buttons__3Tu5R"};